import { createClient } from '@supabase/supabase-js';

// Remplacez par vos vraies valeurs depuis Supabase Dashboard > Settings > API
const supabaseUrl = 'https://ygcqgiythhmvdwxdtqgh.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InlnY3FnaXl0aGhtdmR3eGR0cWdoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjIwMjg0NTYsImV4cCI6MjA3NzYwNDQ1Nn0.N5T2f_xIvfdo5opKS30K4gvzY8fbK5RshLp1Q8QEZV4';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);